import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const awardedForApi = generateNomenApi(`/nomen/awarded-for`);

export const awardedForOptions = generateNomenOptions('awarded-for', awardedForApi);
